import { getBestPriceForDateRangeAction } from "../../../../Actions/LogicActions/Search/GetBestPriceForDateRangeAction";
import { getSearchResultAction } from "../../../../Actions/LogicActions/Search/GetSearchResultAction";
import { uiPreferencesAction } from "../../../../Actions/LogicActions/Search/GetUIPreferencesAction";
import { getFmlmViewInformationAction } from "../../../../Actions/UIActions/FmlmViewInformation/GetFmlmViewInformationAction";
import { openTimerModelAction } from "../../../../Actions/UIActions/FmlmViewInformation/OpenTimerModelAction";
import { openClosePassengerDropdownAction } from "../../../../Actions/UIActions/Search/OpenClosePassengerDropdownAction";
import { openOriginDestinationDropdownAction } from "../../../../Actions/UIActions/Search/OpenOriginDestinationDropdownAction";
import { outboundInboundDateAction } from "../../../../Actions/UIActions/Search/OutboundInboundDateAction";
import { switchOriginDestinationAction } from "../../../../Actions/UIActions/Search/SwitchOriginDestinationAction";
import { modifySearchAction } from "../../../../Actions/UIActions/TrainOffer/ModifySearchAction";
import { ExecutionStatus } from "../../../../core/enum/ExecutionStatus";
import { _eventBus } from "../../../../core/events/EventBus";
import { StepDefinition } from "../../../../core/flows/StepDefinition";
import { StepFlow } from "../../../../core/flows/StepFlow";
import { evtTree, trainOfferEvtTree } from "../../../../Orchestrator/ConstantTree";
import {
  IUserResponse,
  SearchRequestType,
  SearchStateType,
  SearchStateTypeWithDates,
} from "../../../../Orchestrator/Types/Index";
import { showNotification } from "../../../../Services/notificationService";
import { SearchContext } from "../Context/SearchContext";
import { IGetRangeBestPriceActionParams } from "../../../../Orchestrator/Types/Interface/ActionParams/CalendarBestPrice";
import { IFmlmFilter } from "../../../../Orchestrator/Types/Interface/IFmlmView";
import { FmlmViewContext } from "../../../FmlmDetail/Context/FmlmViewContext";
import { favoriteStopAction } from "../../../../Actions/UIActions/Search/FavoriteStopAction";
import { IFavoriteStopActionParams } from "../../../../Orchestrator/Types/Interface/ActionParams/FavoriteStopActionParams";
import { getTranslatedMessage } from "../../../../Lib/Utils/i18n";
import { updateSearchDataForResumeAction } from "../../../../Actions/UIActions/Search/UpdateSearchDataForResumeAction";
import { updateRecoilState } from "../../../../Orchestrator/Recoils/Events/Recoil";
import { fmlmViewInfoTree } from "../../../../Orchestrator/ConstantTree/FmlmSearch/FmlmViewInformationTree";
import { fmlmUpdateFilterAction } from "../../../../Actions/UIActions/FmlmViewInformation/FmlmUpdateFilterAction";
import { TrainTypeEnum } from "../../../../Orchestrator/Types/Enums/globalDefaultEnum";
import { MainBookingContext } from "../../../MainBookingFlow/Context/MainBookingContext";

class SearchInitStep extends StepFlow {
  get stepName() {
    return "SearchStartupInit_Step";
  }

  async onEventSetup(): Promise<void> {
    this.registerEventSubscription(
      _eventBus.on<{ outsideClick: boolean }, void>({
        eventName: evtTree.SearchBar.SelectOrigin.Click,
        handler: async (payload) => {
          let context = this.getCtx<SearchContext>("searchContext");
          if (context) {
            context.field = "origin";
            context.outsideClick = payload.data?.outsideClick || false;
            openOriginDestinationDropdownAction.setParams({
              field: context.field,
              outsideClick: context.outsideClick,
            });
            await openOriginDestinationDropdownAction.execute();
            if (
              openOriginDestinationDropdownAction.status.executionStatus === ExecutionStatus.SUCCESS
            ) {
              context.listOfStops = openOriginDestinationDropdownAction?.result || [];

              context.routeTo = ["SelectSearchStop_Step"];
              this.next();
            }
          }
        },
      })
    );
    this.registerEventSubscription(
      _eventBus.on<{ outsideClick: boolean }, void>({
        eventName: evtTree.SearchBar.SelectDestination.Click,
        handler: async (payload) => {
          let context = this.getCtx<SearchContext>("searchContext")!;
          context.field = "destination";
          context.outsideClick = payload.data?.outsideClick || false;
          await openOriginDestinationDropdownAction.setParams({
            field: context.field,
            outsideClick: context.outsideClick,
          });
          await openOriginDestinationDropdownAction.execute();

          if (
            openOriginDestinationDropdownAction.status.executionStatus === ExecutionStatus.SUCCESS
          ) {
            context.listOfStops = openOriginDestinationDropdownAction?.result || [];

            context.routeTo = ["SelectSearchStop_Step"];
            this.next();
          }
        },
      })
    );

    this.registerEventSubscription(
      _eventBus.on({
        eventName: evtTree.SearchBar.SelectDate.Open,
        handler: async () => {
          let context = this.getCtx<SearchContext>("searchContext")!;
          await uiPreferencesAction.execute();

          context.routeTo = ["SelectSearchDate_Step"];
          this.next();
        },
      })
    );

    this.registerEventSubscription(
      _eventBus.on<IGetRangeBestPriceActionParams, void>({
        eventName: evtTree.SearchBar.SelectDate.BestPrice,
        handler: async (payload) => {
          getBestPriceForDateRangeAction.setParams(payload.data!);
          await getBestPriceForDateRangeAction.execute();
        },
      })
    );

    this.registerEventSubscription(
      _eventBus.on({
        eventName: evtTree.SearchBar.SelectPassenger.Init,
        handler: async () => {
          await openClosePassengerDropdownAction.setParams(true);
          await openClosePassengerDropdownAction.execute();
        },
      })
    );


    this.registerEventSubscription(
      _eventBus.on<boolean, void>({
        eventName: evtTree.SearchBar.SelectPassenger.OpenPopUp,
        handler: async (payload) => {
          let context = this.getCtx<SearchContext>("searchContext")!
          context.isPassengerDropdownOpen = payload.data || false
          await openClosePassengerDropdownAction.setParams(context.isPassengerDropdownOpen)
          await openClosePassengerDropdownAction.execute()

          context.routeTo = ["SelectSearchPassengerType_Step"];
          this.next();
        },
      })
    );
    this.registerEventSubscription(
      _eventBus.on<SearchStateTypeWithDates, void>({
        eventName: evtTree.SearchBar.Select.Switch,
        handler: async (payload) => {
          let context = this.getCtx<SearchContext>("searchContext")!;
          context.searchStateTypeWithDates = payload.data!;
          await switchOriginDestinationAction.setParams({ ...context.searchStateTypeWithDates });
          await switchOriginDestinationAction.execute();
        },
      })
    );

    this.registerEventSubscription(
      _eventBus.on({
        eventName: trainOfferEvtTree.Offer.ModifySearch.Click,
        handler: async (payload) => {
          let context = this.getCtx<SearchContext>("searchContext")!;
          if (context) {
            context.searchFrom = "trainOfferPage";
          }
          await modifySearchAction.setParams(payload.data!);
          await modifySearchAction.execute();
        },
      })
    );
    this.registerEventSubscription(
      _eventBus.on({
        eventName: trainOfferEvtTree.Offer.ModifySearchClose.Click,
        handler: (payload) => {
          modifySearchAction.setParams(payload.data!);
          modifySearchAction.execute();

          const context = this.getCtx<SearchContext>("searchContext")!;
          context.routeTo = [];
          context.nextTo = ["SelectOfferFlow"];
          this.next();
        },
      })
    );

    this.registerEventSubscription(
      _eventBus.on<IFavoriteStopActionParams, void>({
        eventName: evtTree.SearchBar.Favourite.Click,
        handler: async (payload) => {
          favoriteStopAction.setParams(payload.data!)
          await favoriteStopAction.execute()
        }
      })
    )

    this.registerEventSubscription(
      _eventBus.on<SearchStateTypeWithDates, void>({
        eventName: evtTree.SearchBar.SelectDate.Select,
        handler: async (payload) => {
          let context = this.getCtx<SearchContext>("searchContext")!
          context.searchStateTypeWithDates = payload.data!
          await outboundInboundDateAction.setParams({ ...context.searchStateTypeWithDates })
          await outboundInboundDateAction.execute()
          if (outboundInboundDateAction.status.executionStatus === ExecutionStatus.SUCCESS) {
            context.searchStateAtom = outboundInboundDateAction.result!;
          }
        },
      })
    );

    this.registerEventSubscription(
      _eventBus.on<SearchRequestType, void>({
        eventName: evtTree.SearchBar.SearchButton.Click,
        handler: async (payload) => {
          let context = this.getCtx<SearchContext>("searchContext")!;
          // Reset stale checkout mode flags before running a fresh search flow.
          updateRecoilState("isHyperFastStateAtom", false);
          updateRecoilState("isQuickExchangeStateAtom", false);
          updateRecoilState("isChangeDateStateAtom", false);
          updateRecoilState("isUpgradeToPremiumStateAtom", false);
          updateRecoilState("isManageSeatingAtom", false);
          context.searchRequestType = payload.data!;
          if (!payload?.data?.origin || !payload?.data?.destination) {
            // showNotification(
            //   "error",
            //   "Incomplete Selection",
            //   "Please Select Origin & Destination first."
            // );
            showNotification("error", getTranslatedMessage('selectBothOriginAndDestination'), "");
          } else {
            await getSearchResultAction.setParams({ ...context.searchRequestType });
            await getSearchResultAction.execute();
            if (getSearchResultAction.status.executionStatus == ExecutionStatus.SUCCESS) {
              const result = getSearchResultAction.result;
              context.offerResult = result?.data;
              // App parity: never popup — every search lands on the offer
              // page, which renders trains, sold-out services, or its own
              // "no trains" empty state (including TRIP_NO_SEARCH_RESULT
              // backend answers, which the action maps to an empty array).
              const hasSearchAnswer = Array.isArray(result?.data);
              if (result?.result == "shuttle" ||
                (result?.result == "true" && (hasSearchAnswer || context.searchFrom === "trainOfferPage"))) {
                if (result.result == "shuttle") {
                  if (context.searchFrom === "trainOfferPage") {
                    _eventBus.emit({
                      eventName: trainOfferEvtTree.Offer.ModifySearchClose.Click,
                      data: { openModal: false },
                    });
                  } else {
                    const context = this.getCtx<SearchContext>("searchContext")!;
                    context.routeTo = [];
                    this.next();
                  }
                  _eventBus.emit({
                    eventName: "ROUTE_CHANGE",
                    data: "/shuttle",
                  });
                } else {
                  if (context.searchFrom === "trainOfferPage") {
                    _eventBus.emit({
                      eventName: trainOfferEvtTree.Offer.ModifySearchClose.Click,
                      data: { openModal: false },
                    });
                  } else {
                    const context = this.getCtx<SearchContext>("searchContext")!;
                    context.routeTo = [];
                    this.next();
                  }
                  _eventBus.emit({
                    eventName: "ROUTE_CHANGE",
                    data: "/train-offer",
                  });
                }

                //Update searchStateAtom from Resume Search Data
                updateSearchDataForResumeAction.setParams({ ...context.searchRequestType });
                await updateSearchDataForResumeAction.execute();
                //store Last Search Object for "Resume Search".
                localStorage.setItem("resumeSearch", JSON.stringify(payload.data))
              } else if (result?.result == "false") {
                // result "false" = the action's conversion pipeline threw.
                // Surface it — otherwise Search silently does nothing.
                showNotification("error", getTranslatedMessage("apiErrorMsg"), "");
              }
            } else {
              //Action execution fail or something went wrong
            }
          }
        },
      })
    );

    this.registerEventSubscription(
      _eventBus.on<{ search: SearchStateType, searchPopupData: SearchStateType, fmlmFilter: IFmlmFilter, isTimerVisible: boolean, isFromPopUp: boolean, trainType: keyof typeof TrainTypeEnum }, void>({
        eventName: evtTree.SearchBar.TimeSelectModal.Click,
        handler: async (payload) => {
          let searchContext = this.getCtx<SearchContext>("searchContext")!;
          let fmlmContext = this.getCtx<FmlmViewContext>("fmlmViewContext")!;

          const search = payload.data?.search!;
          const searchPopupData = payload.data?.searchPopupData!;
          const fmlmFilter = payload.data?.fmlmFilter!;
          const isTimerVisible = payload.data?.isTimerVisible!;
          const isFromPopUp = payload.data?.isFromPopUp!
          const trainType = payload.data?.trainType!

          await getFmlmViewInformationAction.setParams({
            search: isFromPopUp ? searchPopupData : search,
            fmlmFilter,
            isTimerVisible,
            isFromPopUp,
            trainType: trainType,
          });
          await getFmlmViewInformationAction.execute();

          if (getFmlmViewInformationAction.status.executionStatus == ExecutionStatus.SUCCESS) {
            if (getFmlmViewInformationAction.result?.fmlmView.length === 0) {
              showNotification(
                "error",
                getTranslatedMessage("noFmlmJourneyFound"),
                getTranslatedMessage("tryAgainWithDifferentSearchOrTime")
              );
            }

            if (
              getFmlmViewInformationAction?.result?.fmlmView &&
              getFmlmViewInformationAction.result.fmlmView?.length > 0
            ) {
              // if result get then update the actual state
              if (isFromPopUp) {
                modifySearchAction.setParams({ openModal: false, search, searchPopupData, isPopupConfirm: true, isConfirm: true });
              } else {
                modifySearchAction.setParams({ openModal: false, search, searchPopupData });
              }
              modifySearchAction.execute();

              searchContext.isTimerVisible = payload.data?.isTimerVisible!;
              searchContext.routeTo = []
              searchContext.nextTo = ["FmlmViewFlow"];
              this.next();
              _eventBus.emit({
                eventName: "ROUTE_CHANGE",
                data: "/fmlm-offer",
              });

              //Update searchStateAtom from Resume Search Data
              updateSearchDataForResumeAction.setParams({ search: search, storeLocally: true });
              await updateSearchDataForResumeAction.execute();
            }
          }
        },
      })
    );

    this.registerEventSubscription(
      _eventBus.on<{ isTimerVisible: boolean, resumeSearchData?: SearchStateType }, void>({
        eventName: evtTree.SearchBar.FmlmSearch.Click,
        handler: async ({ data }) => {

          //Update searchStateAtom from Resume Search Data
          if (data?.resumeSearchData) {
            updateRecoilState("isDepartureDateChangedAtom", true)
            updateSearchDataForResumeAction.setParams({ search: data.resumeSearchData, storeLocally: false });
            await updateSearchDataForResumeAction.execute();
          }

          let context = this.getCtx<SearchContext>("searchContext")!;
          context.isTimerVisible = data?.isTimerVisible!;
          openTimerModelAction.setParams({
            isTimerVisible: data?.isTimerVisible!,
          });
          await openTimerModelAction.execute();
        },
      })
    );

    this.registerEventSubscription(
      _eventBus.on<IFmlmFilter, void>({
        eventName: fmlmViewInfoTree.Filter.UpdateFilter,
        handler: async (payload) => {
          fmlmUpdateFilterAction.setParams(payload.data!);
          await fmlmUpdateFilterAction.execute();
        },
      })
    );

    this.registerEventSubscription(
      _eventBus.on<IFmlmFilter, void>({
        eventName: evtTree.MultiBookNow.Click,
        handler: async (payload) => {
          _eventBus.emit({
            eventName: "ROUTE_CHANGE",
            data: "/plan-multi-book",
          });
        },
      })
    );
  }

  async onExecute(): Promise<void> {
    console.log("Search Init Step Execute.............................");

    //Emit this event to call passenger type on Execute to get data.
    _eventBus.emit({
      eventName: evtTree.SearchBar.SelectPassenger.Init
    })
    /**
     * Below code is to handle auto open destination popup for location selection
     * From Origin step it's return a init step of search
     * Here in init we check origin is already selected then tear down the init step automatically
     * and it's start destination step.
     */
    const context = this.getCtx<SearchContext>("searchContext")!;
    if (context && context?.isOriginSelected) {
      context.routeTo = ["SelectSearchStop_Step"];
      context.isOriginSelected = false;
      this.next();
    }

    let mainBookingContext = this.getCtx<MainBookingContext>("MainBookingContext")!
    if (mainBookingContext && mainBookingContext?.isFromDestinationDetail) {
      // this code will be executed if mainBooking flow is executed from destination detail page
      mainBookingContext.isFromDestinationDetail = false;
      if (context) {
        context.routeTo = [];
        this.next()
      }
    }

    const fmlmViewContext = this.getCtx<FmlmViewContext>("fmlmViewContext");
    if (!fmlmViewContext) {
      const newFmlmViewContext = new FmlmViewContext();
      this.setCtx<FmlmViewContext>("fmlmViewContext", newFmlmViewContext);
    }

    if (context && context?.locationMapVisible) {
      context.routeTo = ["FmlmSearchStep"];
      this.next();
    }
  }
}

export const SearchInitStepDeclaration = new StepDefinition({
  stepName: "SearchStartupInit_Step",
  stepClass: SearchInitStep,
});
